export const routes = {
  community: {
    leave: (id: string) => `/communities/${id}/join`,
  },
} as const;
